import React from 'react';

interface IAsyncBoundaryProps {
    children: () => Promise<React.ReactElement | undefined>;
}

const AsyncBoundary: React.FC<IAsyncBoundaryProps> = (props) => {
    const [child, setChild] = React.useState<React.ReactElement>();
    React.useEffect(() => {
        const initChild = async () => {
            props.children().then((newChild) => {
                setChild(newChild);
            });
        };
        initChild();
    }, [props.children]);
    return <>{child}</>;
};

export default AsyncBoundary;
